import { Component, OnInit } from '@angular/core';
import { ProfileService } from '../../../../services/profile.service';
import { users } from '../../../../interfaces/users';
import { EditItemService } from '../../../../services/edit-item.service';
import { Router } from '@angular/router';
import { Item } from '../../../../interfaces/item';
import { UserService } from '../../../../services/user';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
})
export class ProfileComponent implements OnInit {
  userData!: users;
  classToggled: boolean = false;
  contentReady: boolean = true;
  userimage: string = '';
  userPhone: string = '';
  userName: string = '';
  userfirstname: string = '';
  userFacebook: string = '';
  userInstgram: string = '';
  userTiktok: string = '';
  id: string = '';
  hasItems: boolean = false;
  itemData!: Item;
  isMobile: boolean = false;
  isDeliveryHero: boolean = false;
  accountType!: string; // Default value, can be set based on your logic
  defaultAvatarSvg = `
<svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 200 200">
  <defs>
    <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
      <stop offset="0" stop-color="#206ed1"/>
      <stop offset="1" stop-color="#144a94"/>
    </linearGradient>
  </defs>
  <rect width="200" height="200" rx="100" fill="url(#g)"/>
  <circle cx="100" cy="78" r="34" fill="#ffffff" opacity="0.95"/>
  <path d="M40 172c10-34 39-52 60-52s50 18 60 52" fill="#ffffff" opacity="0.95"/>
</svg>
`;
  constructor(
    private _profileService: ProfileService,
    private _editService: EditItemService,
    private _userService: UserService,
    private deviceService: DeviceDetectorService,
    private _router: Router
  ) { }
  ngOnInit(): void {
    this._userService.getAccountType().subscribe({
      next: (data) => {

        this.accountType = data['user_type'];
        this.isDeliveryHero = this.accountType == "8";


      },
      error: (error) => console.error(error),
    });
    this.userId();
  }
  getAvatarSrc(): string {
    const img = (this.userimage || '').trim();
    if (!img) return 'data:image/svg+xml;utf8,' + encodeURIComponent(this.defaultAvatarSvg);
    return img;
  }
  onImageError(event: Event): void {
    const target = event.target as HTMLImageElement;
    target.src = 'data:image/svg+xml;utf8,' + encodeURIComponent(this.defaultAvatarSvg);
  }
  getUserItems(id?: any) {
    this.isMobile = this.deviceService.isMobileDevice();
    this._profileService.getuserinfo(id).subscribe({
      next: (res) => {
        this.contentReady = true;
        this.userData = res;
        console.log(this.userData)
        this.userName = this.userData.username;
        this.userfirstname = this.userData.first_name;
        this.userFacebook = this.userData.facebook_link;
        this.userInstgram = this.userData.instagram_link;
        this.userTiktok = this.userData.tiktok_link;
        this.userPhone = this.userData.phone;
        this.userimage = this.changeUrl(this.userData.image);

        this.hasItems = false;
        this.contentReady = false;
      },
      error: (err) => this.contentReady = false
    });
    this.contentReady = true;
  }
  changeUrl(url: string): string {
    return url.replace('/storage', '');
  }
  userId() {
    this._userService.getUserId().subscribe({
      next: (data) => {
        this.id = data['user_id'];
        this.getUserItems(this.id);
      },
      error: (error) => console.error(error),
    });

  }
}
